$ = require 'jquery'
Auth = require 'db/auth'
EmojiUploaderView = require 'views/internal/autocomplete/emoji-uploader-view'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
TrelloEmoji = require('common/data/emoji').default
l = require 'lib/localize'
popoverEmojiCompleter = require 'views/templates/popover_emoji_completer'
ClientConfig = require 'debug/client-config'

module.exports = class EmojiCompleterView extends View
  viewTitleKey: 'emoji'

  events:
    'mouseenter .js-select-emoji': 'hoverItem'
    'click .js-select-emoji': 'selectEmoji'
    'keydown': 'keydownEvent'
    'keyup .js-filter-emoji': 'keyupEvent'
    'click .js-upload-emoji': 'openEmojiUploader'

  initialize: ->
    @_customEmoji = {}
    if Auth.me().isFeatureEnabled('customEmoji')
      @listenTo Auth.me().customEmojiList, 'change add remove reset', @updateCustomEmoji
      @updateCustomEmoji()
    return

  render: ->
    view = @
    data = {}

    if @options.input
      data.input = true
    if @options.button
      data.button = true

    data.upsellEnabled = !ClientConfig.get('dontUpsell') || Auth.me().isFeatureEnabled('customEmoji')

    @$el.html(
      popoverEmojiCompleter(data)
    )

    @$emojiList = @$('.js-available-emoji')
    if @options.input
      @filterEmoji(@getInput())

    if @options.button
      @fillDefaultEmojiList()

    @

  keyupEvent: (e) ->
    key = Keyboard.getKey(e)

    if key in [Keys.ArrowUp, Keys.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$emojiList, '.item', key)
      return

    else if key in [Keys.Enter, Keys.Tab]
      return

    input = @getInput()
    @filterEmoji(input)

  keydownEvent: (e) ->
    if Keyboard.getKey(e) in [Keys.Enter, Keys.Tab]
      Util.stop(e)
      $item = @$emojiList.find('.item.selected:first .js-select-emoji')
      if $item.length > 0
        $item.click()

  updateCustomEmoji: ->
    @_customEmoji = _.object(Auth.me().customEmojiList.map((e) -> [e.get('name'), e.get('url')]))
    @render()

  getTextInput: ->
    $(@options.target)

  getInput: ->
    if @options.button
      @$('.js-filter-emoji').val()
    else
      $textInput = @getTextInput()
      word = Util.getWordFromCaret($textInput)
      word.str.substring(1)

  filterEmoji: (input) ->
    @clearEmojiList()
    if @fillEmojiList(input)
      Util.selectMenuItem(@$emojiList, '.item', @$emojiList.find('.item').first())

  renderEmojiList: (list) ->

    for e in list
      data =
        name: e
        image: @_customEmoji[e] ? TrelloEmoji[e]

      @$emojiList.append(
        templates.fill(
          'select_emoji',
          data
        )
      )

    @

  fillDefaultEmojiList: (input) ->
    defaultEmoji = [
      'thumbsup'
      'smile'
      'warning'
      'sunglasses'
      'ballot_box_with_check'
      'facepalm'
    ]

    @renderEmojiList(defaultEmoji)

    return

  fillEmojiList: (input) ->
    validatedInput = input.replace(/\W+/g, '')

    if input == ""
      @fillDefaultEmojiList()
      return false
    else if /[A-Z]/.test(validatedInput) && @options.input
      PopOver.hide()
      return false

    validatedInput = validatedInput.toLowerCase()

    @$('.js-upload-emoji')
    .text l('upload emoji named', emojiName: validatedInput)
    .attr 'data-emojiname', validatedInput

    @$('.js-no-matching-emoji-helper')
    .text l('no matching emoji helper', emojiName: validatedInput)

    emojiMatches = @getEmojiSuggestions(validatedInput).slice(0, 6)

    if emojiMatches.length > 0
      @$('.js-results').removeClass('hide')
      @$('.js-no-results').addClass('hide')

      @renderEmojiList(emojiMatches)

    else
      @$('.js-results').addClass('hide')
      @$('.js-no-results').removeClass('hide')

    return emojiMatches.length != 0

  clearEmojiList: ->
    @$emojiList.empty()

  getEmojiSuggestions: (text) ->
    regex = /// ^#{Util.escapeForRegex(text)} ///

    customMatches = (key for key of @_customEmoji when regex.test(key))
    standardMatches = (key for key of TrelloEmoji when regex.test(key))

    # Bias the autocomplete towards popular emoji
    if !@_sortOverride?
      sortOverride = [
        'thumbsup'
        'smile'
        'warning'
        'sunglasses'
        'facepalm'
        'question'
        'thumbsdown'
        'wink'
        'smiley'
        'smile_cat'
        'bowtie'
        'heart'
        'laughing'
        'bug'
        'cry'
        'dancer'
        'dancers'
        'clap'
        'shipit'
        'white_check_mark'
        'star'
        'arrow_down'
        'point_down'
        'point_up'
        'point_left'
        'metal'
      ]

      @_sortOverride = {}
      for entry, index in sortOverride
        @_sortOverride[entry] = index + 1

    # We _.uniq because custom matches override standard matches
    _.uniq([
      customMatches...
      standardMatches...
    ]).sort (a, b) =>
      aOverride = @_sortOverride[a]
      bOverride = @_sortOverride[b]

      if aOverride && !bOverride
        return -1
      else if bOverride && !aOverride
        return 1
      else if aOverride && bOverride
        a = aOverride
        b = bOverride

      if a < b
        -1
      else if a > b
        1
      else
        0

  hoverItem: (e) ->
    $elem = $(e.target).closest('.item')
    Util.selectMenuItem(@$emojiList, '.item', $elem)

  selectEmoji: (e) ->
    Util.stop(e)
    emojiName = $(e.target).closest('.js-select-emoji').find('.emoji-name').text()
    @insertEmoji(emojiName)
    PopOver.hide()

    return

  insertEmoji: (name) ->
    $textInput = @getTextInput()
    if @options.input
      word = Util.getWordFromCaret($textInput)
    else
      caretPosition = Util.getCaretPosition($textInput)
      if caretPosition?
        word =
          start: caretPosition
          end: caretPosition

    Util.insertSelection($textInput, ":" + "#{name}".trim() + ": ", word?.start, word?.end)
    track("Emoji Select", name)

  openEmojiUploader: (e) ->
    Util.stop(e)

    emojiName = @$(e.target).attr('data-emojiname')

    PopOver.pushView
      keepEdits: true
      view: EmojiUploaderView
      options: { model: Auth.me(), emojiName, completerView: @ }

    track("Card Detail", "Open Custom Emoji Uploader")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/internal/autocomplete/emoji-completer-view.coffee